import type { TeamSpace } from "@prismicio/editor-fields"
import { Box, HeaderTabLink } from "@prismicio/editor-ui"
import { z } from "zod"

export const TeamSpaceSettingsTab = z
  .union([z.literal("general"), z.literal("roles")])
  .catch("general")
export type TeamSpaceSettingsTab = z.infer<typeof TeamSpaceSettingsTab>

interface HeaderTabsProps {
  tab: TeamSpaceSettingsTab
  setTab: (tab: TeamSpaceSettingsTab) => void
  teamSpace?: TeamSpace
}

export function HeaderTabs(props: HeaderTabsProps) {
  const { tab, setTab } = props

  return (
    <Box gap={8} minHeight={56} position="relative">
      <div
        // one-off 1px bottom-border behind tab links
        style={{
          position: "absolute",
          bottom: 0,
          height: "1px",
          left: "8px",
          right: "8px",
          backgroundColor: "var(--grey7)",
        }}
      />
      <HeaderTabLink
        text="General"
        onClick={() => setTab("general")}
        selected={tab === "general"}
      />
      <HeaderTabLink
        text="User roles"
        onClick={() => setTab("roles")}
        selected={tab === "roles"}
      />
    </Box>
  )
}
